//  Function to get product details
function getProductDetails() {
  if (typeof window.SwymProductInfo !== 'undefined') {
    return {
      id: window.SwymProductInfo.product.id,
      title: window.SwymProductInfo.product.title,
      price: window.SwymProductInfo.product.price
    };
  }
  return "";
}
function getUserDetails() {
  var shopCurrency = null;
  var customerInfo = null;
  if (window.theme && window.theme.shopCurrency) {
    shopCurrency = window.theme.shopCurrency;
  }
  if (typeof _BISConfig !== 'undefined' && _BISConfig.customer) {
    customerInfo = _BISConfig.customer;
  }
  var user = {
    customer: {
      customerId: null,
      shopCurrency: shopCurrency,
      customer: customerInfo
    }
  };
  if (typeof window.swymCustomerId !== 'undefined' && window.swymCustomerId) {
    user.customer.customerId = window.swymCustomerId;
  }
  return user;
}
 //addto cart details
async function fetchCartDetails(orderkey) {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const queryParams = new URLSearchParams(window.location.search);
    const nostoVal = queryParams.get('nosto');
    const obj = {
      nostoVal: nostoVal,
      product: getProductDetails(),
      user: getUserDetails(),
      domain: window.location.hostname,
      currency: window.theme.shopCurrency,
      currenttime: new Date(),
      cart: cart
    };
    await sendProductDetails(obj, orderkey);
  } catch (error) {
    console.error('Error fetching cart details:', error);
  }
}
// Send product details to backend
async function sendProductDetails(product, orderkey) {
  try {
    let url = "https://app.lateshipment.com/nosto/index.php";
    if (orderkey !== '') {
      url = "https://app.lateshipment.com/nostoprinceorderkey/index.php";
    }
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ product: product })
    });
    await response.text();
   
  } catch (error) {
    console.error("Error sending product details:", error);
  }
}
// Function to add listener to checkout button
function cartitembutton() {
  const allLinks = document.getElementsByTagName('a'); // Get all <a> elements
  let checkoutLink = null;
  // Loop through all links to find the one with the desired text and href
  for (let i = 0; i < allLinks.length; i++) {
    if (allLinks[i].textContent.trim() === 'Checkout' && allLinks[i].getAttribute('href') === '/checkout') {
      checkoutLink = allLinks[i];
      checkoutLink.addEventListener('click', function(event) {
        setTimeout(fetchCartDetails("orderkey"), 1000);
        sessionStorage.removeItem("product__add-to-cart");
      });
    }
  }
}
//  Capture details logic
(function () {
  const url = window.location.href;
  const queryString = window.location.search;
  const queryAddToCart = sessionStorage.getItem("product__add-to-cart");
  if (url != '' && (queryString != '' || queryAddToCart == "true")) {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('nosto') || queryAddToCart == "true") {
      const nostoVal = queryParams.get('nosto');
      const obj = {
        nostoVal: nostoVal,
        product: getProductDetails(),
        user: getUserDetails(),
        currency: window.theme.shopCurrency,
        domain: window.location.hostname,
        currenttime: new Date()
      };
      sendProductDetails(obj, "");
      sessionStorage.setItem("product__add-to-cart", "true");
      // Add listener for add-to-cart button
      document.querySelectorAll('.product__add-to-cart').forEach(button => {
        button.addEventListener('click', async function () {
          await fetchCartDetails("");
          setTimeout(cartitembutton, 600);
        });
      });
      // Add listener for checkout button (delegated)
      document.addEventListener('click', async (event) => {
        const button = event.target.closest('.cart__checkout-button');
        if (button) {
          event.preventDefault();
          await fetchCartDetails("orderkey");
          window.location.href = "/checkout";
        }
      });
    }
  }
})();
